<template>
    <div class="mobile_content content_box permission-upload">
        <div class="content permission-upload">
            <el-upload
                class="upload"
                drag
                :action="uploadUrl"
                :headers="{'Authorization': 'Bearer ' + ($store.state.token)}"
                >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            </el-upload>
        </div>
    </div>
</template>
<script>
export default({
    name: 'permission-upload',
    data() {
        return {
            file_list: '',
            uploadUrl: process.env.BASE_API + 'permission/init',
        }
    },
    created() {
        
    },
    methods: {
        
    }
})
</script>
<style lang="less" scoped>
    .upload{
        max-width: 360px;
    }
</style>



// WEBPACK FOOTER //
// src/view/settings/permission-upload.vue